import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/**
 * Link para uma rota de um produto específico.
 *
 * Existia pra atravessar ORIGENS quando Consórcio e Seguros viviam em hosts
 * separados: fora do módulo ativo, virava <a href> pro outro host, com reload
 * de página inteira. Com host único (ver product-module.ts) isso acabou —
 * agora é sempre navegação de SPA.
 *
 * O componente permanece porque os pontos de chamada continuam corretos
 * semanticamente ("este link é do consórcio") e porque documenta a travessia
 * entre produtos, que continua sendo uma travessia de contexto mesmo sendo
 * barata. Não é indireção morta: é onde a regra moraria de novo se um dia os
 * produtos voltarem a se separar.
 */
export const ProductLink = ({
  to,
  children,
  className,
  title,
}: {
  /** Mantido por clareza no ponto de chamada; não altera o comportamento. */
  module?: "consortium" | "insurance";
  to: string;
  children: ReactNode;
  className?: string;
  title?: string;
}) => (
  <Link to={to} className={className} title={title}>
    {children}
  </Link>
);
